import "./FormationTimeline.scss";

const formatTime = (sec) => `${Math.floor(sec / 60)}'`;

const TRIGGER_LABELS = {
  substitution_rebuild: "sub",
  organic_shift: "shift",
};

export default function FormationTimeline({ timeline, matchTimeSec, label }) {
  if (!timeline || !timeline.length) return null;

  // Only show runs where formation changed (skip the initial one)
  const changes = timeline.filter((_, i) => i > 0);

  return (
    <div className="formation-timeline">
      <span className="timeline-label">{label}:</span>
      <span className="timeline-start">{timeline[0].formation}</span>
      {changes.map((run, i) => {
        const trigger = TRIGGER_LABELS[run.trigger] || "";
        return (
          <span key={i} className={`timeline-change trigger-${run.trigger || "unknown"}`}>
            {formatTime(run.start_sec)} → {run.formation}
            {trigger && <span className="trigger-tag">{trigger}</span>}
          </span>
        );
      })}
      {changes.length === 0 && (
        <span className="timeline-no-changes">no changes</span>
      )}
    </div>
  );
}
